"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleBarChart = exports.CircleBarChartWrapper = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SvgArcHelper_1 = require("../../utils/SvgArcHelper");
exports.CircleBarChartWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: ", "px;\n\tdisplay: inline-block;\n"], ["\n\tmargin: ", "px;\n\tdisplay: inline-block;\n"])), function (props) { return props.marginSize; });
exports.CircleBarChartWrapper.displayName = 'CircleBarChartWrapper';
var CircleBarChart = /** @class */ (function (_super) {
    __extends(CircleBarChart, _super);
    function CircleBarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircleBarChart.prototype.render = function () {
        var height;
        var marginSize;
        var subtextFontSize;
        var unitFontSize;
        var strokeWidth;
        var subtextLinebreakLimit;
        switch (this.props.size) {
            default:
            case 'lg':
                height = 325;
                marginSize = 20;
                subtextFontSize = 4.15;
                unitFontSize = this.props.unitSize === 'lg' ? 12 : 7.5;
                strokeWidth = 10;
                subtextLinebreakLimit = 27;
                break;
            case 'md':
                height = 200;
                marginSize = 15;
                subtextFontSize = 5;
                unitFontSize = this.props.unitSize === 'lg' ? 12 : 9;
                strokeWidth = 11.5;
                subtextLinebreakLimit = 26;
                break;
            case 'sm':
                height = 170;
                marginSize = 10;
                subtextFontSize = 6;
                unitFontSize = this.props.unitSize === 'lg' ? 12 : 9;
                strokeWidth = 11.5;
                subtextLinebreakLimit = 25;
                break;
        }
        var renderValue = this.props.value || 0;
        var svgArcHelper = new SvgArcHelper_1.SvgArcHelper(50, 50, -90, 270);
        var radius = 50 - strokeWidth / 2;
        var filledDValue = svgArcHelper.describeArc(radius, 0, renderValue);
        // leave a white space if this score is above 0;
        var emptyDValue = svgArcHelper.describeArc(radius, renderValue !== 0 ? renderValue + 0.5 : 0, 100);
        var splitSubtext = [];
        if (this.props.subtext !== undefined) {
            var textLine = this.props.subtext;
            do {
                if (textLine.length > subtextLinebreakLimit) {
                    var substring = textLine.substr(0, subtextLinebreakLimit);
                    var spaceIndex = substring.lastIndexOf(' ');
                    if (spaceIndex > -1) {
                        // we found a space before the linebreak limit.
                        splitSubtext.push(textLine.substr(0, spaceIndex));
                        textLine = textLine.substr(spaceIndex + 1);
                    }
                    else {
                        var nextSpaceIndex = textLine.indexOf(' ');
                        if (nextSpaceIndex > -1) {
                            splitSubtext.push(textLine.substr(0, nextSpaceIndex));
                            textLine = textLine.substr(nextSpaceIndex + 1);
                        }
                        else {
                            // no spaces in the string. don't break up
                            splitSubtext.push(textLine);
                            textLine = '';
                        }
                    }
                }
                else {
                    // text is less than the linebreak limit
                    splitSubtext.push(textLine);
                    textLine = '';
                }
            } while (textLine.length);
        }
        var displayValue = this.props.displayValue || this.props.value;
        return (React.createElement(exports.CircleBarChartWrapper, { marginSize: marginSize },
            React.createElement("svg", { height: height, viewBox: '0 0 100 100', preserveAspectRatio: 'xMinYMin' },
                React.createElement("path", { id: 'incompleteArc', fill: 'none', d: emptyDValue, stroke: '#cccccc', strokeWidth: strokeWidth }),
                React.createElement("path", { id: 'completeArc', fill: 'none', stroke: '#5C2E8E', d: filledDValue, strokeWidth: strokeWidth }),
                displayValue !== undefined && (React.createElement("text", { id: 'score-value', x: '50', y: splitSubtext.length ? 55 : 59, fontWeight: 'bold', textAnchor: 'middle', fill: '#444444' },
                    React.createElement("tspan", { fontSize: '28' }, displayValue),
                    React.createElement("tspan", { fontSize: unitFontSize }, this.props.unit))),
                splitSubtext.map(function (line, index) {
                    return (React.createElement("text", { id: 'subtext-' + (index + 1), x: '50', y: displayValue !== undefined ? 64 : 52, dy: index * 5, key: index, fontSize: subtextFontSize, fontWeight: '600', textAnchor: 'middle', fill: '#656565' }, line));
                }))));
    };
    return CircleBarChart;
}(React.Component));
exports.CircleBarChart = CircleBarChart;
var templateObject_1;
